import { createConfirmation } from "react-confirm";
import TextInputDialog from "./TextInputDialog";

export const showTextInputDialog = createConfirmation(TextInputDialog);
